export default "__VITE_ASSET__CICCLMui__"